import { IconPhoto } from '@tabler/icons-react';
import { useCallback } from 'react';
import { getRemotionEnvironment } from 'remotion';
import { useRemotionUsage } from '../../MainPlayer/RemotionUsageContext/RemotionUsageContext';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';
import { SpeakerWithDetails } from '@/player-config/src/types/speaker-types';

export default function AudiogramEmptyProfilePicture({ speaker }: { speaker?: SpeakerWithDetails }) {
  const { isPlayer } = getRemotionEnvironment();

  const { isSharedPage } = useRemotionUsage();
  const showHelpText = isPlayer && !isSharedPage;

  const openContentSettings = useCallback(() => {
    if (showHelpText) {
      EventBus.dispatch(CustomEvents.OpenContentSettings, { speakerId: speaker?.id });
    }
  }, [showHelpText, speaker?.id]);

  return (
    <div className="relative size-full">
      <div
        className="absolute z-10 flex size-full flex-col items-center justify-center gap-[2%] bg-slate-200 text-center text-4xl leading-normal text-slate-500"
        data-testid="placeholder-container"
      >
        <IconPhoto size={showHelpText ? '5%' : '8%'} />
        {showHelpText && (
          <p className="max-w-[400px] text-[40px]">
            Add a speaker image in the
            <span className="pointer-events-auto cursor-pointer underline" onClick={openContentSettings}>
              {' '}
              settings{' '}
            </span>
            menu
          </p>
        )}
      </div>
    </div>
  );
}
